import { createAction } from 'redux-actions';
import { actionKey } from './constants';
// Dynamic redux
export const reduxModuleLoaded = createAction(`${actionKey}.REDUX_READY`, ()=>({}));
export const openNftLinkPopup = createAction(`${actionKey}.OPEN_NFT_LINK_POPUP`, (deviation)=>({
        deviation
    }));
export const deleteNft = createAction(`${actionKey}.DELETE_NFT`, (deviation, nft)=>({
        deviation,
        nft
    }));
export const updateNft = createAction(`${actionKey}.UPDATE_NFT`, (deviation, nftData, nft)=>({
        deviation,
        nft,
        nftData
    }));
